import { capitalize } from "lodash";
import { CloseRounded } from "@mui/icons-material";
import { Box, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { colors, fonts } from "../../theme";
import { CountryCode, useGetAttributeProductsQuery } from "../../generated/storefront";
import { FrameType } from "../../helpers/basket";

type Props = {
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
  selectedCountry: CountryCode;
};

const BoxFrameDialog = ({ dialogOpen, setDialogOpen, selectedCountry }: Props) => {
  const { data: attributeProductsData } = useGetAttributeProductsQuery({
    variables: { country: selectedCountry },
  });
  const { premiumFrameProduct } = attributeProductsData || {};

  return (
    <Dialog onClose={() => setDialogOpen(false)} open={dialogOpen}>
      <CloseRounded
        onClick={() => setDialogOpen(false)}
        sx={{
          cursor: "pointer",
          position: "absolute",
          top: 0,
          right: 0,
          background: colors.white,
          borderRadius: "100%",
          margin: 1,
          padding: 1,
          width: 32,
          height: 32,
          zIndex: 10,
        }}
      />

      <DialogContent>
        <Stack gap={2}>
          <Box
            height={{ xs: "calc(100vw - 80px)", md: 500 }}
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              src={premiumFrameProduct?.images.nodes[1]?.src}
              alt={FrameType.Premium + " frame"}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>
          <Stack gap={1}>
            <Typography variant="h4">Frame type</Typography>
            <Stack gap={2}>
              <Typography fontSize={{ xs: 12, md: 14 }} fontFamily={fonts.body}>
                Our {capitalize(FrameType.Premium)} Frame features a bold box profile measuring 20mm on the front face and 33mm in
                depth, it offers a more dimensional, gallery-style presence.
              </Typography>
              <Typography fontSize={{ xs: 12, md: 14 }} fontFamily={fonts.body}>
                In comparison, our {capitalize(FrameType.Standard)} Frame maintains a sleek 23mm depth for a more minimalist look.
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default BoxFrameDialog;
